import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../utils/apiAuth";

export const saveUserData = createAsyncThunk(
  "auth/saveUserData",
  async (userData, { rejectWithValue }) => {
    try {
      const response = await api.post("/auth/register-step-1", userData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Kayıt Başarısız"
      );
    }
  }
);

export const sendCode = createAsyncThunk(
  "auth/sendCode",
  async (dataToSend, { rejectWithValue }) => {
    try {
      const response = await api.post("/auth/register-step-2", dataToSend);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Kod Doğrulama Başarısız"
      );
    }
  }
);

export const saveKariyerData = createAsyncThunk(
  "auth/saveKariyerData",
  async (userData, { rejectWithValue }) => {
    try {
      const response = await api.post("/auth/register-step-3", userData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Kariyer Bilgileri Kaydedilemedi"
      );
    }
  }
);

export const loginUser = createAsyncThunk(
  "auth/loginUser",
  async (loginData, { rejectWithValue }) => {
    try {
      const response = await api.post("/auth/login", loginData);

      if (!response.data) {
        return rejectWithValue("Sunucudan yanıt alınamadı");
      }

      if (!response.data.accessToken) {
        return rejectWithValue("Giriş başarısız: Token alınamadı");
      }

      return response.data;
    } catch (error) {
      if (error.response?.status === 401) {
        return rejectWithValue("Lütfen e-posta ve şifrenizi kontrol ediniz");
      }
      return rejectWithValue(
        error.response?.data?.message || "Giriş yapılırken bir hata oluştu"
      );
    }
  }
);

export const refreshAccessToken = createAsyncThunk(
  "auth/refreshAccessToken",
  async (_, { rejectWithValue, getState }) => {
    const { auth } = getState();
    /* console.log(
      "refreshAccessToken action çağrıldı, isAuthenticated:",
      auth.isAuthenticated
    ); */
    // if (auth.isAuthenticated === false) {
    //   return;
    // }
    try {
      const response = await api.post("/auth/refresh-access-token");
     /*  console.log("refresh-access-token API response:", response.data); */
      return response.data;
    } catch (error) {
      /* console.error("refresh-access-token API error:", error); */
      return rejectWithValue(
        error.message || "Refresh token geçersiz veya süresi dolmuş."
      );
    }
  }
);

export const logoutUser = createAsyncThunk(
  "auth/logoutUser",
  async (_, { rejectWithValue }) => {
    try {
      await api.post("/auth/logout");
      return true;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Çıkış işlemi başarısız!"
      );
    }
  }
);
